export default function SideNavDivider() {
  return <div className="mx-3 my-2 border-b border-gray-200" />;
}
